module.exports = __webpack_public_path__ + "img/50coin.d1eac186.png";